import { useWebStoreContext } from "contexts";
import { useGetOffersQuery } from "redux/apis";
import useNewDay from "hooks/useNewDay";
import { useEffect } from "react";

const useLoadOffers = () => {
	const { authToken } = useWebStoreContext();
	const { newDay } = useNewDay();

	const { refetch: refetchLoyaltyOffers } = useGetOffersQuery(
		{
			offerType: "loyalty",
			isAuthenticated: !!authToken?.value
		},
		{ pollingInterval: 1200000 } // 20 minutes
	);
	const { refetch: refetchPurchaseOffers } = useGetOffersQuery(
		{
			offerType: "singleItem",
			isAuthenticated: !!authToken?.value
		},
		{ pollingInterval: 1200000 } // 20 minutes
	);

	const { refetch: refetchFeaturedDeals } = useGetOffersQuery(
		{
			offerType: "featured",
			isAuthenticated: !!authToken?.value
		},
		{ pollingInterval: 1200000 } // 20 minutes
	);

	useEffect(() => {
		refetchLoyaltyOffers();
		refetchPurchaseOffers();
		refetchFeaturedDeals();
	}, [newDay]);
};

export default useLoadOffers;
